import React from 'react'
import {
  KYC_NOTICE_PARAGRAPHS,
  KYC_NOTICE_TITLE,
  KYC_PENDING_BANNER_TEXT,
} from '../../lib/kycNoticeState.js'

export type KycNoticeMode = 'signup' | 'dismissible' | 'wall' | 'pending_banner'

interface KycRequiredNoticeProps {
  mode: KycNoticeMode
  rejectionReason?: string | null
  onClose?: () => void
  onContinueToKyc?: () => void
  onLogout?: () => void
}

export const KycRequiredNotice: React.FC<KycRequiredNoticeProps> = ({
  mode,
  rejectionReason,
  onClose,
  onContinueToKyc,
  onLogout,
}) => {
  if (mode === 'pending_banner') {
    return (
      <div
        role="status"
        style={{
          margin: '12px 16px 0',
          padding: '12px 16px',
          borderRadius: 10,
          background: 'rgba(202, 138, 4, 0.12)',
          border: '1px solid rgba(250, 204, 21, 0.35)',
          color: '#FEF3C7',
          display: 'flex',
          gap: 12,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
      >
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5 }}>{KYC_PENDING_BANNER_TEXT}</p>
        {onClose ? (
          <button
            type="button"
            onClick={onClose}
            aria-label="Dismiss KYC review notice"
            style={{
              flexShrink: 0,
              background: 'transparent',
              border: 'none',
              color: '#FDE68A',
              cursor: 'pointer',
              fontSize: 18,
              lineHeight: 1,
            }}
          >
            ×
          </button>
        ) : null}
      </div>
    )
  }

  const canClose = mode === 'signup' || mode === 'dismissible'
  const isWall = mode === 'wall'

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="kyc-notice-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 80,
        background: 'rgba(0, 0, 0, 0.72)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 560,
          maxHeight: '90vh',
          overflowY: 'auto',
          background: '#121212',
          border: '1px solid rgba(250, 204, 21, 0.35)',
          borderRadius: 16,
          padding: 28,
          boxShadow: '0 16px 48px rgba(0,0,0,0.55)',
          color: '#F9FAFB',
        }}
      >
        <h2 id="kyc-notice-title" style={{ margin: '0 0 16px', fontSize: 22, color: '#FACC15' }}>
          {KYC_NOTICE_TITLE}
        </h2>
        {KYC_NOTICE_PARAGRAPHS.map((para) => (
          <p key={para.slice(0, 24)} style={{ margin: '0 0 12px', fontSize: 14, lineHeight: 1.6, color: '#E5E7EB' }}>
            {para}
          </p>
        ))}
        {rejectionReason ? (
          <p style={{ margin: '8px 0 16px', fontSize: 13, color: '#FCA5A5' }}>
            Previous review: {rejectionReason}
          </p>
        ) : null}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 20 }}>
          {isWall && onContinueToKyc ? (
            <button
              type="button"
              onClick={onContinueToKyc}
              style={{
                background: '#EAB308',
                color: '#111827',
                border: 'none',
                borderRadius: 8,
                padding: '10px 16px',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Continue to KYC
            </button>
          ) : null}
          {isWall && onLogout ? (
            <button
              type="button"
              onClick={onLogout}
              style={{
                background: 'transparent',
                color: '#D1D5DB',
                border: '1px solid #4B5563',
                borderRadius: 8,
                padding: '10px 16px',
                cursor: 'pointer',
              }}
            >
              Log out
            </button>
          ) : null}
          {canClose && onClose ? (
            <button
              type="button"
              onClick={onClose}
              style={{
                background: '#EAB308',
                color: '#111827',
                border: 'none',
                borderRadius: 8,
                padding: '10px 16px',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Close
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
